var timeout, drop_hover;
var modal_duration = 400;
var modal_overlay = document.createElement('div');
var contact_modal_id = document.getElementById('contact-modal');
var contact_modal_wrap = document.getElementById('contact-modal-wrap');

//var restock_modal_id = document.getElementById('restock_modal');
//var restock_modal_wrap = document.getElementById('restock_modal_wrap');

//var restock_modal_close = document.getElementById('restock_modal_close');

var dbody = document.body;

var modal_open = 0;

const contact_modal = document.getElementsByClassName('contact-modal');

modal_overlay.id = 'modal-overlay';

import {
	disableBodyScroll,
	enableBodyScroll,
	clearAllBodyScrollLocks
} from 'body-scroll-lock';

import {
	gsap
} from "gsap";
import {
	ScrollToPlugin
} from "gsap/ScrollToPlugin";
import {
	ScrollTrigger
} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

var modal_duration = .4;

//console.log(contact_modal);

if (contact_modal) {

	for (let i = 0; i < contact_modal.length; i++) {

		contact_modal[i].addEventListener('click', function (e) {

			// set target selector
			var target = contact_modal_id;

			dbody.appendChild(modal_overlay);

			disableBodyScroll(contact_modal_wrap);

			dbody.classList.add('is-modal-open');

			//
			//	setTimeout(function () {
			gsap.fromTo(modal_overlay, {
				opacity: 0,
				//	height: 0,
				display: 'block',

			}, {
				opacity: 1,
				//	height: target_menu.scrollHeight,
				duration: modal_duration,
				onComplete: function () {
					//	sp_drawer_menu.classList.add('is-open');
					modal_overlay.style.removeProperty('opacity');
					modal_overlay.style.removeProperty('display');
					//	target_menu.style.removeProperty('height');
					//	siteheader.style.removeProperty('position');
					//	siteheader.style.removeProperty('transform');
					//dbody.removeChild(drawer_overlay);
				}
			});

			gsap.fromTo(target, {
				opacity: 0,
				//	height: 0,
				display: 'block',

			}, {
				opacity: 1,
				//	height: target_menu.scrollHeight,
				duration: modal_duration,
				onComplete: function () {
					//	sp_drawer_menu.classList.add('is-open');

					target.style.removeProperty('opacity');
					target.style.removeProperty('display');
					target.classList.add('is-open');
					//	target_menu.style.removeProperty('height');
					//	siteheader.style.removeProperty('position');
					//	siteheader.style.removeProperty('transform');
					//dbody.removeChild(drawer_overlay);
				}
			});

			//	});
			/*
			window.setTimeout(function () {
				anime({
					targets: target,
					delay: 10,
					opacity: 1,
					duration: modal_duration,
					easing: 'easeOutQuad',
					begin: function (anim) {
						//	target_parent.classList.add('slideout');
					},
					complete: function (anim) {
						//		target_parent.classList.remove('open');
						//		target_parent.classList.remove('slideout');
						target.style.removeProperty('display');
						target.style.removeProperty('opacity');
						target.classList.add('open');

					}
				});
			});
			*/
			e.preventDefault();

		});

	}

}

var modal_close_target = document.querySelectorAll('.modal__close');

for (let j = 0; j < modal_close_target.length; j++) {

	modal_close_target[j].addEventListener('click', function (e) {

		//		console.log(e.currentTarget);
//		var modal_target = e.currentTarget.closest('.modal');
        var modalopen = document.querySelectorAll('.modal.is-open');
	var modal_target = document.getElementById(modalopen[0].id);

		modal_close(modal_target);

		e.preventDefault();


	});

}

/*
restock_modal_close.addEventListener('click', function (e) {

	//		console.log(e.currentTarget);
	//var modal_target = e.currentTarget.closest('.modal');

	//		console.log(modal_target);


	modal_close(restock_modal_id);

	e.preventDefault();


});
*/
modal_overlay.addEventListener('click', function (e) {

	//console.log('over lay click');

	var openmodal = document.querySelectorAll('.modal.is-open');
	var target_modal = document.getElementById(openmodal[0].id);
	//console.log(openmodal[0].id);
	//modal_close(login_modal_id);

	modal_close(target_modal);
	e.preventDefault();
	//console.log('click');

});

function modal_close(modal_target) {


	gsap.fromTo(modal_overlay, {
		opacity: 1,
		//	height: 0,
		//	display: 'block',

	}, {
		opacity: 0,
		//	height: target_menu.scrollHeight,
		duration: modal_duration,
		onComplete: function () {
			//	sp_drawer_menu.classList.add('is-open');
			modal_overlay.style.removeProperty('opacity');
			//	modal_overlay.style.removeProperty('display');
			//	target_menu.style.removeProperty('height');
			//	siteheader.style.removeProperty('position');
			//	siteheader.style.removeProperty('transform');
			//dbody.removeChild(drawer_overlay);

			dbody.removeChild(modal_overlay);
		}
	});

	gsap.fromTo(modal_target, {
		opacity: 1,
		//	height: 0,
		//	display: 'block',

	}, {
		opacity: 0,
		//	height: target_menu.scrollHeight,
		duration: modal_duration,
		onComplete: function () {
			//	sp_drawer_menu.classList.add('is-open');
			modal_target.classList.remove('is-open');
			modal_target.style.removeProperty('opacity');
			modal_target.style.removeProperty('display');
			//	target.classList.add('is-open');
			//	target_menu.style.removeProperty('height');
			//	siteheader.style.removeProperty('position');
			//	siteheader.style.removeProperty('transform');
			//dbody.removeChild(drawer_overlay);
		}
	});




	//menu_open = 0;

	dbody.classList.remove('is-modal-open');

	//console.log(modal_overlay);



	clearAllBodyScrollLocks();


}